import type { ReactNode } from "react";

interface ArticleLayoutProps {
  children: ReactNode;
  backTo?: string;
  backLabel?: string;
  canonicalPath?: string;
}

export default function ArticleLayout({ children, backTo = "/", backLabel = "Back to Home" }: ArticleLayoutProps) {
  return (
    <main className="min-h-screen bg-background-50">
      <nav className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2 group cursor-pointer">
              <i className="ri-arrow-left-line text-foreground-600 group-hover:text-foreground-950 transition-colors"></i>
              <span className="font-heading text-lg font-bold text-foreground-950 tracking-tight">
                hipobuyspread<span className="text-primary-500">.</span>beer
              </span>
            </a>
            <a
              href={backTo}
              className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors duration-150 whitespace-nowrap cursor-pointer"
            >
              {backLabel}
            </a>
          </div>
        </div>
      </nav>

      <article className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          {children}
        </div>
      </article>

      <footer className="w-full bg-foreground-950 text-background-50 py-10">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <a href="/" className="inline-block mb-3">
              <span className="font-heading text-lg font-bold text-background-50 tracking-tight">
                hipobuyspread<span className="text-primary-400">.</span>beer
              </span>
            </a>
            <p className="text-xs text-foreground-400">
              &copy; 2026 hipobuyspread.beer — All rights reserved. &nbsp;|&nbsp;
              <a href="/" className="hover:text-background-50 transition-colors cursor-pointer">Home</a>
              &nbsp;|&nbsp;
              <a href="/hipobuy-spreadsheet-guide" className="hover:text-background-50 transition-colors cursor-pointer">Beginner Guide</a>
              &nbsp;|&nbsp;
              <a href="/hipobuy-spreadsheet-review" className="hover:text-background-50 transition-colors cursor-pointer">Review</a>
              &nbsp;|&nbsp;
              <a href="/hipobuy-spreadsheet-safety" className="hover:text-background-50 transition-colors cursor-pointer">Safety</a>
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
}